<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
    version="1.1"
    id="back"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 935 127.5"
    style="enable-background:new 0 0 935 127.5;"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill: #c1022d;
        }
    </style>
    <path
        class="st0"
        d="M77.7,33.3l-4.8,18H40.9l-2.7,9.3h32l-4.8,17.7H7.3l12.1-45.1H77.7z M84.2,10.2l-4.4,16.6H15.3l10.6-16.6H84.2z
	"
    />
    <path
        class="st0"
        d="M155.1,33.3l-12.5,45.2l-36.2,0.1C95,78.6,88,75.2,85.2,68.4c-0.7-1.9-1.1-3.7-1.1-5.5c0-1.1,0.1-2.1,0.4-3
	l7.3-26.5l22,0l-7,24.6c-0.3,1.1-0.5,2-0.5,2.5c0,1.3,0.7,2.2,2,2.6h15.8l8.4-29.6H155.1z M120.1,10.5l-4.5,16.2H93.2l4.7-16.2
	H120.1z M161.2,10.6l-4.6,16.2H134l4.6-16.2L161.2,10.6z"
    />
    <path
        class="st0"
        d="M242,33.3c-0.5,4-2.9,7.8-6.9,11.4c-1.9,1.6-3.4,2.7-4.6,3.1c1.5,2.4,2.3,4.8,2.3,7.4c0,1.5-0.2,3.7-0.7,6.5
	c-0.3,1.7-2,7.3-5.2,16.7h-22.2l7.9-27.2h-23.3l-8.4,27.2h-23.1l13.3-45.1H242z M243.2,26.7h-76.7L177,10.2h56.3
	c1.5,0,3.1,0.5,4.7,1.6c1.5,1,2.7,2.3,3.4,3.7C242.6,17.7,243.2,21.5,243.2,26.7z"
    />
    <path
        class="st0"
        d="M318.4,33.2l-0.4,1.5c-1,3.4-2.8,9.7-5.4,18.8c-1.6,5.8-4.1,10.6-7.6,14.5c-6.2,7-14.6,10.5-25,10.5h-11.8
	c-6.3,0-11.3-1.2-15-3.5c-4.5-2.9-6.8-7.3-6.8-13.2c0-3.2,0.5-6.5,1.5-10.1l5-18.3h23.1L269,57.5c-0.3,1.1-0.5,2-0.5,2.6
	c0,1.3,0.6,2.1,1.8,2.5h14.4c1.8-0.5,3.2-2.2,4-5l7.1-24.1L318.4,33.2z M319.7,26.8h-65.2c1.3-4.4,3.6-8.2,6.8-11.3
	c3.9-3.8,7.9-5.7,12-5.7H307c8.5,0,12.8,4.5,12.8,13.5C319.7,25.6,319.7,26.8,319.7,26.8z"
    />
    <path
        class="st0"
        d="M379.3,60.2l-5.2,18.5h-31.4c-10.9,0-17.8-3.5-20.8-10.5c-0.9-2.1-1.2-5-0.9-8.7c0.1-0.7,0.2-2.1,0.4-4l5.8-22
	l24.6-0.1l-7.1,21.9c0.2,0.9,0.4,1.7,0.6,2.6c0.6,1.2,1.8,2,3.7,2.4H379.3z M393.3,10.2l-4.9,16.6h-59.3c1.2-4.1,3.5-7.7,6.9-11
	c3.8-3.7,7.7-5.6,11.7-5.6H393.3z"
    />
    <path
        class="st0"
        d="M467.8,33.2l-0.4,1.5c-1,3.4-2.8,9.7-5.4,18.8c-1.6,5.8-4.1,10.6-7.6,14.5c-6.2,7-14.6,10.5-25,10.5h-11.8
	c-6.3,0-11.3-1.2-15-3.5c-4.5-2.9-6.8-7.3-6.8-13.2c0-3.2,0.5-6.5,1.5-10.1l5-18.3h23.1l-6.8,24.1c-0.3,1.1-0.5,2-0.5,2.6
	c0,1.3,0.6,2.1,1.8,2.5h14.4c1.8-0.5,3.2-2.2,4-5l7.1-24.1L467.8,33.2z M469.1,26.8h-65.2c1.3-4.4,3.6-8.2,6.8-11.3
	c3.9-3.8,7.9-5.7,12-5.7h33.6c8.5,0,12.8,4.5,12.8,13.5C469.1,25.6,469.1,26.8,469.1,26.8z"
    />
    <path
        class="st0"
        d="M557.6,33.3l-12.8,45.1h-24.7l11.4-40.5l-16.7,13.5l-13.9-13.5l-11.5,40.5h-22.9l12.6-45.1H557.6z M563.8,10.2
	l-4.7,16.6h-78.4l4.6-16.6h23.2l13.7,13.2l16.9-13.2H563.8z"
    />
    <path
        class="st0"
        d="M651.1,33.3l-12.8,45.1h-24.7L625,37.9l-16.7,13.5l-13.9-13.5l-11.5,40.5H560l12.6-45.1H651.1z M657.3,10.2
	l-4.7,16.6h-78.4l4.6-16.6h23.2l13.7,13.2l16.9-13.2H657.3z"
    />
    <path
        class="st0"
        d="M732.7,78.4h-24.8l-6.7-26.9h-14l-19.9,26.9l-29,0l35.4-45.2H723L732.7,78.4z M721.7,26.8h-42.7l14.2-16.6h25
	L721.7,26.8z"
    />
    <path
        class="st0"
        d="M811.2,33.3l-12,45.1h-24.8l7.6-27.4l-14.5-13.1l-11.5,40.7h-22.6l12.4-45.3H811.2z M817.4,10.2l-4.9,16.5
	h-64.9l4.7-16.5h22.5l14.6,13.9l3.5-13.9H817.4z"
    />
    <path
        class="st0"
        d="M891.5,33.3c0,11.6-2.3,20.8-6.8,27.4c-3.6,5.3-6.9,9.1-9.9,11.3c-6,4.5-13.4,6.7-22.4,6.7H813l13-45.4h24.4
	l-8.2,27.7c1.5,0.6,3.2,0.9,5,0.9c3.3,0,6.8-1,10.3-3c5.8-3.3,9.5-7.9,11.3-14c0.9-3.2,1.5-7,1.6-11.6H891.5z M890.2,26.8h-68.6
	l10.6-16.6h39.9c4.3,0,8.3,1.7,12.1,5C888.1,18.7,890.1,22.6,890.2,26.8z"
    />
    <g>
        <path
            class="st0"
            d="M929.2,25.5c0,8.4-6.6,14.9-15.1,14.9c-8.5,0-15.2-6.6-15.2-14.9c0-8.2,6.7-14.7,15.2-14.7
		C922.6,10.7,929.2,17.3,929.2,25.5z M902.6,25.5c0,6.6,4.9,11.8,11.5,11.8c6.5,0,11.2-5.2,11.2-11.7c0-6.6-4.8-11.9-11.3-11.9
		C907.5,13.7,902.6,19,902.6,25.5z M911.7,33.2h-3.4V18.5c1.3-0.3,3.2-0.4,5.7-0.4c2.8,0,4,0.4,5.1,1.1c0.8,0.6,1.4,1.8,1.4,3.2
		c0,1.6-1.3,2.9-3.1,3.4v0.2c1.4,0.5,2.2,1.6,2.7,3.6c0.4,2.2,0.7,3.1,1.1,3.7h-3.7c-0.5-0.5-0.7-1.9-1.2-3.6
		c-0.3-1.6-1.2-2.3-3.1-2.3h-1.6V33.2z M911.8,24.8h1.6c1.9,0,3.4-0.6,3.4-2.2c0-1.3-1-2.2-3.1-2.2c-0.9,0-1.5,0.1-1.9,0.2V24.8z"
        />
    </g>
    <g>
        <path d="M7.4,96.1v-3.9h4.3v3.9H7.4z M7.4,114.3V98.3h4.3v16.1H7.4z" />
        <path
            d="M33.6,114.3h-4.3v-8.2c0-1.7-0.1-2.9-0.3-3.4c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.9-0.4-1.5-0.4c-0.7,0-1.4,0.2-2,0.6
		c-0.6,0.4-1,0.9-1.2,1.6c-0.2,0.7-0.3,1.9-0.3,3.7v7.3h-4.3V98.3h4v2.4c1.4-1.8,3.2-2.7,5.3-2.7c0.9,0,1.8,0.2,2.6,0.5
		c0.8,0.3,1.4,0.8,1.8,1.3c0.4,0.5,0.7,1.1,0.8,1.8c0.2,0.7,0.2,1.6,0.2,2.9V114.3z"
        />
        <path
            d="M48.2,98.3v3.4h-2.9v6.5c0,1.3,0,2.1,0.1,2.3c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0,1-0.1,1.7-0.4
		l0.4,3.3c-1,0.4-2.1,0.6-3.4,0.6c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.1-0.6-1.4-1c-0.3-0.4-0.5-1-0.6-1.7c-0.1-0.5-0.1-1.5-0.1-3v-7
		h-2v-3.4h2v-3.2l4.3-2.5v5.7H48.2z"
        />
        <path
            d="M63.3,109.2l4.2,0.7c-0.5,1.6-1.4,2.7-2.6,3.5c-1.2,0.8-2.6,1.2-4.4,1.2c-2.8,0-4.9-0.9-6.2-2.7c-1.1-1.5-1.6-3.3-1.6-5.5
		c0-2.7,0.7-4.8,2.1-6.3c1.4-1.5,3.2-2.3,5.3-2.3c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2,4,2,7.3H57.1c0,1.3,0.4,2.2,1,2.9
		c0.7,0.7,1.5,1.1,2.5,1.1c0.7,0,1.2-0.2,1.7-0.5C62.8,110.6,63.1,110,63.3,109.2z M63.6,104.9c0-1.2-0.3-2.2-1-2.8
		c-0.6-0.6-1.3-1-2.2-1c-0.9,0-1.7,0.3-2.3,1c-0.6,0.7-0.9,1.6-0.9,2.8H63.6z"
        />
        <path
            d="M73.8,115.4l4.9,0.6c0.1,0.6,0.3,1,0.6,1.2c0.4,0.3,1,0.5,1.9,0.5c1.1,0,1.9-0.2,2.5-0.5c0.4-0.2,0.7-0.6,0.8-1.1
		c0.1-0.4,0.2-1,0.2-2v-2.3c-1.3,1.7-2.9,2.6-4.8,2.6c-2.2,0-3.9-0.9-5.1-2.7c-1-1.4-1.5-3.2-1.5-5.4c0-2.7,0.6-4.8,1.9-6.2
		c1.3-1.4,2.9-2.1,4.8-2.1c2,0,3.6,0.9,4.9,2.6v-2.3h4v14.4c0,1.9-0.2,3.3-0.5,4.3c-0.3,0.9-0.8,1.7-1.3,2.2c-0.6,0.5-1.3,1-2.3,1.3
		c-0.9,0.3-2.1,0.5-3.6,0.5c-2.7,0-4.7-0.5-5.8-1.4c-1.1-0.9-1.7-2.1-1.7-3.5C73.8,115.8,73.8,115.6,73.8,115.4z M77.6,106
		c0,1.7,0.3,3,1,3.7c0.7,0.8,1.5,1.2,2.4,1.2c1,0,1.9-0.4,2.6-1.2c0.7-0.8,1.1-2,1.1-3.6c0-1.7-0.3-2.9-1-3.7
		c-0.7-0.8-1.6-1.2-2.6-1.2c-1,0-1.9,0.4-2.5,1.2C77.9,103.1,77.6,104.3,77.6,106z"
        />
        <path
            d="M100.1,114.3h-4.3V98.3h4v2.3c0.7-1.1,1.3-1.8,1.8-2.1c0.5-0.3,1.2-0.5,1.8-0.5c1,0,1.9,0.3,2.8,0.8l-1.3,3.7
		c-0.7-0.5-1.4-0.7-2-0.7c-0.6,0-1.1,0.2-1.5,0.5c-0.4,0.3-0.7,0.9-1,1.8c-0.2,0.9-0.4,2.7-0.4,5.4V114.3z"
        />
        <path
            d="M114.2,103.2l-3.9-0.7c0.4-1.6,1.2-2.7,2.2-3.5c1.1-0.7,2.6-1.1,4.7-1.1c1.9,0,3.3,0.2,4.2,0.7c0.9,0.4,1.6,1,2,1.7
		c0.4,0.7,0.6,2,0.6,3.8l0,5c0,1.4,0.1,2.5,0.2,3.1c0.1,0.7,0.4,1.4,0.8,2.2h-4.2c-0.1-0.3-0.2-0.7-0.4-1.3
		c-0.1-0.3-0.1-0.4-0.2-0.5c-0.7,0.7-1.5,1.2-2.3,1.6c-0.8,0.4-1.7,0.5-2.6,0.5c-1.7,0-3-0.4-3.9-1.3c-1-0.9-1.4-2-1.4-3.4
		c0-0.9,0.2-1.7,0.7-2.4c0.4-0.7,1-1.3,1.8-1.6c0.8-0.4,1.9-0.7,3.4-1c2-0.4,3.4-0.7,4.1-1v-0.4c0-0.8-0.2-1.4-0.6-1.7
		c-0.4-0.3-1.2-0.5-2.3-0.5c-0.8,0-1.3,0.1-1.8,0.4C114.8,101.9,114.5,102.4,114.2,103.2z M119.9,106.6c-0.5,0.2-1.4,0.4-2.6,0.7
		c-1.2,0.3-2,0.5-2.3,0.7c-0.6,0.4-0.8,0.9-0.8,1.5c0,0.6,0.2,1.1,0.7,1.5c0.4,0.4,1,0.7,1.7,0.7c0.8,0,1.5-0.3,2.2-0.8
		c0.5-0.4,0.9-0.9,1-1.4c0.1-0.4,0.2-1.1,0.2-2.1V106.6z"
        />
        <path
            d="M138.5,98.3v3.4h-2.9v6.5c0,1.3,0,2.1,0.1,2.3c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0,1-0.1,1.7-0.4
		l0.4,3.3c-1,0.4-2.1,0.6-3.4,0.6c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.1-0.6-1.4-1c-0.3-0.4-0.5-1-0.6-1.7c-0.1-0.5-0.1-1.5-0.1-3v-7
		h-2v-3.4h2v-3.2l4.3-2.5v5.7H138.5z"
        />
        <path
            d="M153.7,109.2l4.2,0.7c-0.5,1.6-1.4,2.7-2.6,3.5c-1.2,0.8-2.6,1.2-4.4,1.2c-2.8,0-4.9-0.9-6.2-2.7c-1.1-1.5-1.6-3.3-1.6-5.5
		c0-2.7,0.7-4.8,2.1-6.3c1.4-1.5,3.2-2.3,5.3-2.3c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2,4,2,7.3h-10.7c0,1.3,0.4,2.2,1,2.9
		c0.7,0.7,1.5,1.1,2.5,1.1c0.7,0,1.2-0.2,1.7-0.5C153.1,110.6,153.5,110,153.7,109.2z M154,104.9c0-1.2-0.3-2.2-1-2.8
		c-0.6-0.6-1.3-1-2.2-1c-0.9,0-1.7,0.3-2.3,1c-0.6,0.7-0.9,1.6-0.9,2.8H154z"
        />
        <path
            d="M179.3,114.3h-4V112c-0.7,0.9-1.4,1.6-2.3,2.1c-0.9,0.4-1.8,0.7-2.7,0.7c-1.8,0-3.4-0.7-4.7-2.2c-1.3-1.5-2-3.6-2-6.2
		c0-2.7,0.6-4.8,1.9-6.2c1.3-1.4,2.9-2.1,4.9-2.1c1.8,0,3.4,0.7,4.7,2.2v-8h4.3V114.3z M167.9,105.9c0,1.7,0.2,3,0.7,3.7
		c0.7,1.1,1.6,1.7,2.9,1.7c1,0,1.8-0.4,2.5-1.2c0.7-0.8,1-2.1,1-3.7c0-1.8-0.3-3.2-1-4c-0.7-0.8-1.5-1.2-2.6-1.2
		c-1,0-1.9,0.4-2.5,1.2C168.3,103.2,167.9,104.3,167.9,105.9z"
        />
        <path
            d="M196.4,109.7l4.3-0.7c0.2,0.8,0.5,1.5,1.1,1.9c0.6,0.4,1.3,0.6,2.3,0.6c1.1,0,1.9-0.2,2.5-0.6c0.4-0.3,0.6-0.7,0.6-1.1
		c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.4-1.4-0.6c-3.4-0.8-5.6-1.4-6.5-2.1c-1.3-0.9-1.9-2.1-1.9-3.6c0-1.4,0.5-2.6,1.6-3.5
		c1.1-0.9,2.8-1.4,5.1-1.4c2.2,0,3.8,0.4,4.9,1.1c1.1,0.7,1.8,1.8,2.2,3.2l-4,0.7c-0.2-0.6-0.5-1.1-1-1.4c-0.5-0.3-1.2-0.5-2.1-0.5
		c-1.1,0-1.9,0.2-2.4,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.8c0.4,0.3,1.7,0.7,4,1.2c2.3,0.5,3.8,1.1,4.7,1.9
		c0.9,0.8,1.3,1.8,1.3,3.2c0,1.5-0.6,2.7-1.8,3.8c-1.2,1.1-3.1,1.6-5.5,1.6c-2.2,0-3.9-0.4-5.2-1.3
		C197.7,112.5,196.8,111.3,196.4,109.7z"
        />
        <path
            d="M217.1,106.1c0-1.4,0.3-2.8,1-4.1c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1,4.3-1c2.4,0,4.4,0.8,6,2.4c1.6,1.6,2.3,3.6,2.3,6
		c0,2.4-0.8,4.4-2.4,6c-1.6,1.6-3.5,2.4-5.9,2.4c-1.5,0-2.9-0.3-4.2-1c-1.3-0.7-2.4-1.6-3.1-2.9
		C217.5,109.5,217.1,107.9,217.1,106.1z M221.5,106.3c0,1.6,0.4,2.8,1.1,3.7c0.8,0.8,1.7,1.3,2.8,1.3c1.1,0,2-0.4,2.8-1.3
		c0.8-0.8,1.1-2.1,1.1-3.7c0-1.6-0.4-2.8-1.1-3.6c-0.8-0.8-1.7-1.3-2.8-1.3c-1.1,0-2,0.4-2.8,1.3
		C221.8,103.5,221.5,104.7,221.5,106.3z"
        />
        <path d="M239.9,114.3V92.1h4.3v22.2H239.9z" />
        <path
            d="M262,114.3v-2.4c-0.6,0.9-1.4,1.5-2.3,2c-1,0.5-2,0.7-3,0.7c-1.1,0-2-0.2-2.9-0.7c-0.9-0.5-1.5-1.1-1.9-2
		c-0.4-0.9-0.6-2-0.6-3.6V98.3h4.3v7.4c0,2.3,0.1,3.6,0.2,4.2c0.2,0.5,0.4,0.9,0.9,1.2c0.4,0.3,0.9,0.4,1.6,0.4c0.7,0,1.4-0.2,2-0.6
		c0.6-0.4,1-0.9,1.2-1.5c0.2-0.6,0.3-2,0.3-4.3v-6.8h4.3v16.1H262z"
        />
        <path
            d="M280.7,98.3v3.4h-2.9v6.5c0,1.3,0,2.1,0.1,2.3c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0,1-0.1,1.7-0.4
		l0.4,3.3c-1,0.4-2.1,0.6-3.4,0.6c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.1-0.6-1.4-1c-0.3-0.4-0.5-1-0.6-1.7c-0.1-0.5-0.1-1.5-0.1-3v-7
		h-2v-3.4h2v-3.2l4.3-2.5v5.7H280.7z"
        />
        <path d="M286.6,96.1v-3.9h4.3v3.9H286.6z M286.6,114.3V98.3h4.3v16.1H286.6z" />
        <path
            d="M297.1,106.1c0-1.4,0.3-2.8,1-4.1c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1,4.3-1c2.4,0,4.4,0.8,6,2.4c1.6,1.6,2.3,3.6,2.3,6
		c0,2.4-0.8,4.4-2.4,6c-1.6,1.6-3.5,2.4-5.9,2.4c-1.5,0-2.9-0.3-4.2-1c-1.3-0.7-2.4-1.6-3.1-2.9
		C297.4,109.5,297.1,107.9,297.1,106.1z M301.5,106.3c0,1.6,0.4,2.8,1.1,3.7c0.8,0.8,1.7,1.3,2.8,1.3c1.1,0,2-0.4,2.8-1.3
		c0.8-0.8,1.1-2.1,1.1-3.7c0-1.6-0.4-2.8-1.1-3.6c-0.8-0.8-1.7-1.3-2.8-1.3c-1.1,0-2,0.4-2.8,1.3
		C301.8,103.5,301.5,104.7,301.5,106.3z"
        />
        <path
            d="M334.6,114.3h-4.3v-8.2c0-1.7-0.1-2.9-0.3-3.4c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.9-0.4-1.5-0.4c-0.7,0-1.4,0.2-2,0.6
		c-0.6,0.4-1,0.9-1.2,1.6c-0.2,0.7-0.3,1.9-0.3,3.7v7.3h-4.3V98.3h4v2.4c1.4-1.8,3.2-2.7,5.3-2.7c0.9,0,1.8,0.2,2.6,0.5
		c0.8,0.3,1.4,0.8,1.8,1.3c0.4,0.5,0.7,1.1,0.8,1.8c0.2,0.7,0.2,1.6,0.2,2.9V114.3z"
        />
        <path
            d="M340.3,109.7l4.3-0.7c0.2,0.8,0.5,1.5,1.1,1.9c0.6,0.4,1.3,0.6,2.3,0.6c1.1,0,1.9-0.2,2.5-0.6c0.4-0.3,0.6-0.7,0.6-1.1
		c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.4-1.4-0.6c-3.4-0.8-5.6-1.4-6.5-2.1c-1.3-0.9-1.9-2.1-1.9-3.6c0-1.4,0.5-2.6,1.6-3.5
		c1.1-0.9,2.8-1.4,5.1-1.4c2.2,0,3.8,0.4,4.9,1.1c1.1,0.7,1.8,1.8,2.2,3.2l-4,0.7c-0.2-0.6-0.5-1.1-1-1.4c-0.5-0.3-1.2-0.5-2.1-0.5
		c-1.1,0-1.9,0.2-2.4,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.8c0.4,0.3,1.7,0.7,4,1.2c2.3,0.5,3.8,1.1,4.7,1.9
		c0.9,0.8,1.3,1.8,1.3,3.2c0,1.5-0.6,2.7-1.8,3.8c-1.2,1.1-3.1,1.6-5.5,1.6c-2.2,0-3.9-0.4-5.2-1.3
		C341.5,112.5,340.7,111.3,340.3,109.7z"
        />
        <path
            d="M371.6,98.3h2.4V97c0-1.4,0.1-2.4,0.4-3c0.3-0.7,0.8-1.2,1.6-1.6c0.8-0.4,1.7-0.6,2.9-0.6c1.2,0,2.4,0.2,3.6,0.5l-0.6,3
		c-0.7-0.2-1.3-0.2-2-0.2c-0.6,0-1.1,0.1-1.3,0.4c-0.3,0.3-0.4,0.8-0.4,1.7v1.1h3.2v3.3h-3.2v12.7H374v-12.7h-2.4V98.3z"
        />
        <path
            d="M385.7,106.1c0-1.4,0.3-2.8,1-4.1c0.7-1.3,1.7-2.3,3-3c1.3-0.7,2.7-1,4.3-1c2.4,0,4.4,0.8,6,2.4c1.6,1.6,2.3,3.6,2.3,6
		c0,2.4-0.8,4.4-2.4,6c-1.6,1.6-3.5,2.4-5.9,2.4c-1.5,0-2.9-0.3-4.2-1c-1.3-0.7-2.4-1.6-3.1-2.9
		C386.1,109.5,385.7,107.9,385.7,106.1z M390.1,106.3c0,1.6,0.4,2.8,1.1,3.7c0.8,0.8,1.7,1.3,2.8,1.3c1.1,0,2-0.4,2.8-1.3
		c0.8-0.8,1.1-2.1,1.1-3.7c0-1.6-0.4-2.8-1.1-3.6c-0.8-0.8-1.7-1.3-2.8-1.3c-1.1,0-2,0.4-2.8,1.3
		C390.5,103.5,390.1,104.7,390.1,106.3z"
        />
        <path
            d="M412.6,114.3h-4.3V98.3h4v2.3c0.7-1.1,1.3-1.8,1.8-2.1c0.5-0.3,1.2-0.5,1.8-0.5c1,0,1.9,0.3,2.8,0.8l-1.3,3.7
		c-0.7-0.5-1.4-0.7-2-0.7c-0.6,0-1.1,0.2-1.5,0.5c-0.4,0.3-0.7,0.9-1,1.8c-0.2,0.9-0.4,2.7-0.4,5.4V114.3z"
        />
        <path
            d="M434.9,98.3h4v2.4c0.5-0.8,1.2-1.5,2.1-2c0.9-0.5,1.9-0.8,2.9-0.8c1.9,0,3.5,0.7,4.8,2.2c1.3,1.5,2,3.5,2,6.1
		c0,2.7-0.7,4.8-2,6.3c-1.3,1.5-2.9,2.2-4.8,2.2c-0.9,0-1.7-0.2-2.4-0.5c-0.7-0.4-1.5-1-2.3-1.8v8.1h-4.3V98.3z M439.1,106
		c0,1.8,0.4,3.1,1.1,4c0.7,0.9,1.6,1.3,2.6,1.3c1,0,1.8-0.4,2.5-1.2c0.7-0.8,1-2.1,1-3.9c0-1.7-0.3-2.9-1-3.8
		c-0.7-0.8-1.5-1.2-2.5-1.2c-1,0-1.9,0.4-2.6,1.2C439.5,103.3,439.1,104.4,439.1,106z"
        />
        <path
            d="M467.5,114.3v-2.4c-0.6,0.9-1.4,1.5-2.3,2c-1,0.5-2,0.7-3,0.7c-1.1,0-2-0.2-2.9-0.7c-0.9-0.5-1.5-1.1-1.9-2
		c-0.4-0.9-0.6-2-0.6-3.6V98.3h4.3v7.4c0,2.3,0.1,3.6,0.2,4.2c0.2,0.5,0.4,0.9,0.9,1.2c0.4,0.3,0.9,0.4,1.6,0.4c0.7,0,1.4-0.2,2-0.6
		c0.6-0.4,1-0.9,1.2-1.5c0.2-0.6,0.3-2,0.3-4.3v-6.8h4.3v16.1H467.5z"
        />
        <path
            d="M478.6,114.3V92.1h4.3v8c1.3-1.5,2.9-2.2,4.7-2.2c2,0,3.6,0.7,4.9,2.1c1.3,1.4,1.9,3.5,1.9,6.1c0,2.7-0.7,4.9-2,6.3
		c-1.3,1.5-2.9,2.2-4.8,2.2c-0.9,0-1.8-0.2-2.7-0.7c-0.9-0.5-1.7-1.1-2.3-2v2.4H478.6z M482.8,105.9c0,1.7,0.3,2.9,0.8,3.7
		c0.7,1.1,1.7,1.7,2.9,1.7c0.9,0,1.7-0.4,2.4-1.2c0.7-0.8,1-2.1,1-3.8c0-1.8-0.3-3.2-1-4c-0.7-0.8-1.5-1.2-2.6-1.2
		c-1,0-1.9,0.4-2.5,1.2C483.1,103.1,482.8,104.3,482.8,105.9z"
        />
        <path d="M500.6,114.3V92.1h4.3v22.2H500.6z" />
        <path d="M512.1,96.1v-3.9h4.3v3.9H512.1z M512.1,114.3V98.3h4.3v16.1H512.1z" />
        <path
            d="M537.7,103l-4.2,0.8c-0.1-0.8-0.5-1.5-1-1.9c-0.5-0.4-1.1-0.6-1.9-0.6c-1.1,0-1.9,0.4-2.5,1.1c-0.6,0.7-0.9,2-0.9,3.7
		c0,1.9,0.3,3.3,1,4c0.6,0.8,1.5,1.2,2.6,1.2c0.8,0,1.5-0.2,2-0.7c0.5-0.5,0.9-1.2,1.1-2.4l4.2,0.7c-0.4,1.9-1.3,3.4-2.5,4.3
		c-1.2,1-2.9,1.5-5,1.5c-2.4,0-4.2-0.7-5.6-2.2c-1.4-1.5-2.1-3.5-2.1-6.2c0-2.7,0.7-4.7,2.1-6.2c1.4-1.5,3.3-2.2,5.7-2.2
		c2,0,3.5,0.4,4.7,1.3C536.3,100,537.2,101.3,537.7,103z"
        />
        <path
            d="M553.8,109.7l4.3-0.7c0.2,0.8,0.5,1.5,1.1,1.9c0.6,0.4,1.3,0.6,2.3,0.6c1.1,0,1.9-0.2,2.5-0.6c0.4-0.3,0.6-0.7,0.6-1.1
		c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.4-1.4-0.6c-3.4-0.8-5.6-1.4-6.5-2.1c-1.3-0.9-1.9-2.1-1.9-3.6c0-1.4,0.6-2.6,1.7-3.5
		c1.1-0.9,2.8-1.4,5.1-1.4c2.2,0,3.8,0.4,4.9,1.1c1.1,0.7,1.8,1.8,2.2,3.2l-4,0.7c-0.2-0.6-0.5-1.1-1-1.4c-0.5-0.3-1.2-0.5-2.1-0.5
		c-1.1,0-1.9,0.2-2.4,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.8c0.4,0.3,1.7,0.7,4,1.2c2.3,0.5,3.8,1.1,4.7,1.9
		c0.9,0.8,1.3,1.8,1.3,3.2c0,1.5-0.6,2.7-1.8,3.8c-1.2,1.1-3.1,1.6-5.5,1.6c-2.2,0-3.9-0.4-5.2-1.3
		C555.1,112.5,554.2,111.3,553.8,109.7z"
        />
        <path
            d="M578.7,103.2l-3.9-0.7c0.4-1.6,1.2-2.7,2.2-3.5c1.1-0.7,2.6-1.1,4.7-1.1c1.9,0,3.3,0.2,4.2,0.7c0.9,0.4,1.6,1,2,1.7
		c0.4,0.7,0.6,2,0.6,3.8l0,5c0,1.4,0.1,2.5,0.2,3.1c0.1,0.7,0.4,1.4,0.8,2.2h-4.2c-0.1-0.3-0.2-0.7-0.4-1.3
		c-0.1-0.3-0.1-0.4-0.2-0.5c-0.7,0.7-1.5,1.2-2.3,1.6c-0.8,0.4-1.7,0.5-2.6,0.5c-1.7,0-3-0.4-3.9-1.3c-1-0.9-1.4-2-1.4-3.4
		c0-0.9,0.2-1.7,0.7-2.4c0.4-0.7,1-1.3,1.8-1.6c0.8-0.4,1.9-0.7,3.4-1c2-0.4,3.4-0.7,4.1-1v-0.4c0-0.8-0.2-1.4-0.6-1.7
		c-0.4-0.3-1.2-0.5-2.3-0.5c-0.8,0-1.3,0.1-1.8,0.4C579.3,101.9,578.9,102.4,578.7,103.2z M584.4,106.6c-0.5,0.2-1.4,0.4-2.6,0.7
		c-1.2,0.3-2,0.5-2.3,0.7c-0.6,0.4-0.8,0.9-0.8,1.5c0,0.6,0.2,1.1,0.7,1.5c0.4,0.4,1,0.7,1.7,0.7c0.8,0,1.5-0.3,2.2-0.8
		c0.5-0.4,0.9-0.9,1-1.4c0.1-0.4,0.2-1.1,0.2-2.1V106.6z"
        />
        <path
            d="M593.8,98.3h2.4V97c0-1.4,0.1-2.4,0.4-3c0.3-0.7,0.8-1.2,1.6-1.6c0.8-0.4,1.7-0.6,2.9-0.6c1.2,0,2.4,0.2,3.6,0.5l-0.6,3
		c-0.7-0.2-1.3-0.2-2-0.2c-0.6,0-1.1,0.1-1.3,0.4c-0.3,0.3-0.4,0.8-0.4,1.7v1.1h3.2v3.3h-3.2v12.7h-4.3v-12.7h-2.4V98.3z"
        />
        <path
            d="M618.2,109.2l4.2,0.7c-0.5,1.6-1.4,2.7-2.6,3.5c-1.2,0.8-2.6,1.2-4.4,1.2c-2.8,0-4.9-0.9-6.2-2.7c-1.1-1.5-1.6-3.3-1.6-5.5
		c0-2.7,0.7-4.8,2.1-6.3c1.4-1.5,3.2-2.3,5.3-2.3c2.4,0,4.3,0.8,5.7,2.4c1.4,1.6,2,4,2,7.3H612c0,1.3,0.4,2.2,1,2.9
		c0.7,0.7,1.5,1.1,2.5,1.1c0.7,0,1.2-0.2,1.7-0.5C617.6,110.6,618,110,618.2,109.2z M618.4,104.9c0-1.2-0.3-2.2-1-2.8
		c-0.6-0.6-1.3-1-2.2-1c-0.9,0-1.7,0.3-2.3,1c-0.6,0.7-0.9,1.6-0.9,2.8H618.4z"
        />
        <path
            d="M636.4,98.3v3.4h-2.9v6.5c0,1.3,0,2.1,0.1,2.3c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0,1-0.1,1.7-0.4
		l0.4,3.3c-1,0.4-2.1,0.6-3.4,0.6c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.1-0.6-1.4-1c-0.3-0.4-0.5-1-0.6-1.7c-0.1-0.5-0.1-1.5-0.1-3v-7
		h-2v-3.4h2v-3.2l4.3-2.5v5.7H636.4z"
        />
        <path
            d="M640.3,98.3h4.5l3.8,11.4l3.8-11.4h4.4l-5.7,15.5l-1,2.8c-0.4,0.9-0.7,1.7-1.1,2.1c-0.3,0.5-0.7,0.9-1.2,1.2
		c-0.4,0.3-1,0.5-1.6,0.7c-0.6,0.2-1.4,0.3-2.2,0.3c-0.8,0-1.6-0.1-2.4-0.3l-0.4-3.3c0.7,0.1,1.3,0.2,1.8,0.2c1,0,1.7-0.3,2.2-0.9
		c0.5-0.6,0.8-1.3,1.1-2.2L640.3,98.3z"
        />
        <path
            d="M677.1,103.2l-3.9-0.7c0.4-1.6,1.2-2.7,2.2-3.5c1.1-0.7,2.6-1.1,4.7-1.1c1.9,0,3.3,0.2,4.2,0.7c0.9,0.4,1.6,1,2,1.7
		c0.4,0.7,0.6,2,0.6,3.8l0,5c0,1.4,0.1,2.5,0.2,3.1c0.1,0.7,0.4,1.4,0.8,2.2h-4.2c-0.1-0.3-0.2-0.7-0.4-1.3
		c-0.1-0.3-0.1-0.4-0.2-0.5c-0.7,0.7-1.5,1.2-2.3,1.6c-0.8,0.4-1.7,0.5-2.6,0.5c-1.7,0-3-0.4-3.9-1.3c-1-0.9-1.4-2-1.4-3.4
		c0-0.9,0.2-1.7,0.7-2.4c0.4-0.7,1-1.3,1.8-1.6c0.8-0.4,1.9-0.7,3.4-1c2-0.4,3.4-0.7,4.1-1v-0.4c0-0.8-0.2-1.4-0.6-1.7
		c-0.4-0.3-1.2-0.5-2.3-0.5c-0.8,0-1.3,0.1-1.8,0.4C677.7,101.9,677.4,102.4,677.1,103.2z M682.8,106.6c-0.5,0.2-1.4,0.4-2.6,0.7
		c-1.2,0.3-2,0.5-2.3,0.7c-0.6,0.4-0.8,0.9-0.8,1.5c0,0.6,0.2,1.1,0.7,1.5c0.4,0.4,1,0.7,1.7,0.7c0.8,0,1.5-0.3,2.2-0.8
		c0.5-0.4,0.9-0.9,1-1.4c0.1-0.4,0.2-1.1,0.2-2.1V106.6z"
        />
        <path
            d="M708.7,114.3h-4.3v-8.2c0-1.7-0.1-2.9-0.3-3.4c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.9-0.4-1.5-0.4c-0.7,0-1.4,0.2-2,0.6
		c-0.6,0.4-1,0.9-1.2,1.6s-0.3,1.9-0.3,3.7v7.3h-4.3V98.3h4v2.4c1.4-1.8,3.2-2.7,5.3-2.7c0.9,0,1.8,0.2,2.6,0.5
		c0.8,0.3,1.4,0.8,1.8,1.3c0.4,0.5,0.7,1.1,0.8,1.8c0.2,0.7,0.2,1.6,0.2,2.9V114.3z"
        />
        <path
            d="M730.7,114.3h-4V112c-0.7,0.9-1.4,1.6-2.3,2.1c-0.9,0.4-1.8,0.7-2.7,0.7c-1.8,0-3.4-0.7-4.7-2.2c-1.3-1.5-2-3.6-2-6.2
		c0-2.7,0.6-4.8,1.9-6.2c1.3-1.4,2.9-2.1,4.9-2.1c1.8,0,3.4,0.7,4.7,2.2v-8h4.3V114.3z M719.4,105.9c0,1.7,0.2,3,0.7,3.7
		c0.7,1.1,1.6,1.7,2.9,1.7c1,0,1.8-0.4,2.5-1.2c0.7-0.8,1-2.1,1-3.7c0-1.8-0.3-3.2-1-4c-0.7-0.8-1.5-1.2-2.6-1.2
		c-1,0-1.9,0.4-2.5,1.2C719.7,103.2,719.4,104.3,719.4,105.9z"
        />
        <path d="M749.3,96.1v-3.9h4.3v3.9H749.3z M749.3,114.3V98.3h4.3v16.1H749.3z" />
        <path
            d="M775.5,114.3h-4.3v-8.2c0-1.7-0.1-2.9-0.3-3.4c-0.2-0.5-0.5-0.9-0.9-1.2c-0.4-0.3-0.9-0.4-1.5-0.4c-0.7,0-1.4,0.2-2,0.6
		c-0.6,0.4-1,0.9-1.2,1.6s-0.3,1.9-0.3,3.7v7.3h-4.3V98.3h4v2.4c1.4-1.8,3.2-2.7,5.3-2.7c0.9,0,1.8,0.2,2.6,0.5
		c0.8,0.3,1.4,0.8,1.8,1.3c0.4,0.5,0.7,1.1,0.8,1.8c0.2,0.7,0.2,1.6,0.2,2.9V114.3z"
        />
        <path
            d="M797.5,114.3h-4V112c-0.7,0.9-1.4,1.6-2.3,2.1c-0.9,0.4-1.8,0.7-2.7,0.7c-1.8,0-3.4-0.7-4.7-2.2c-1.3-1.5-2-3.6-2-6.2
		c0-2.7,0.6-4.8,1.9-6.2c1.3-1.4,2.9-2.1,4.9-2.1c1.8,0,3.4,0.7,4.7,2.2v-8h4.3V114.3z M786.1,105.9c0,1.7,0.2,3,0.7,3.7
		c0.7,1.1,1.6,1.7,2.9,1.7c1,0,1.8-0.4,2.5-1.2c0.7-0.8,1-2.1,1-3.7c0-1.8-0.3-3.2-1-4c-0.7-0.8-1.5-1.2-2.6-1.2
		c-1,0-1.9,0.4-2.5,1.2C786.4,103.2,786.1,104.3,786.1,105.9z"
        />
        <path
            d="M815.1,114.3v-2.4c-0.6,0.9-1.4,1.5-2.3,2c-1,0.5-2,0.7-3,0.7c-1.1,0-2-0.2-2.9-0.7c-0.9-0.5-1.5-1.1-1.9-2
		c-0.4-0.9-0.6-2-0.6-3.6V98.3h4.3v7.4c0,2.3,0.1,3.6,0.2,4.2c0.2,0.5,0.4,0.9,0.9,1.2c0.4,0.3,0.9,0.4,1.6,0.4c0.7,0,1.4-0.2,2-0.6
		c0.6-0.4,1-0.9,1.2-1.5c0.2-0.6,0.3-2,0.3-4.3v-6.8h4.3v16.1H815.1z"
        />
        <path
            d="M824.9,109.7l4.3-0.7c0.2,0.8,0.5,1.5,1.1,1.9c0.6,0.4,1.3,0.6,2.3,0.6c1.1,0,1.9-0.2,2.5-0.6c0.4-0.3,0.6-0.7,0.6-1.1
		c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.7-0.4-1.4-0.6c-3.4-0.8-5.6-1.4-6.5-2.1c-1.3-0.9-1.9-2.1-1.9-3.6c0-1.4,0.6-2.6,1.7-3.5
		c1.1-0.9,2.8-1.4,5.1-1.4c2.2,0,3.8,0.4,4.9,1.1c1.1,0.7,1.8,1.8,2.2,3.2l-4,0.7c-0.2-0.6-0.5-1.1-1-1.4c-0.5-0.3-1.2-0.5-2.1-0.5
		c-1.1,0-1.9,0.2-2.4,0.5c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.6,0.4,0.8c0.4,0.3,1.7,0.7,4,1.2c2.3,0.5,3.8,1.1,4.7,1.9
		c0.9,0.8,1.3,1.8,1.3,3.2c0,1.5-0.6,2.7-1.8,3.8c-1.2,1.1-3.1,1.6-5.5,1.6c-2.2,0-3.9-0.4-5.2-1.3
		C826.1,112.5,825.3,111.3,824.9,109.7z"
        />
        <path
            d="M853.9,98.3v3.4H851v6.5c0,1.3,0,2.1,0.1,2.3c0.1,0.2,0.2,0.4,0.4,0.5c0.2,0.1,0.4,0.2,0.7,0.2c0.4,0,1-0.1,1.7-0.4
		l0.4,3.3c-1,0.4-2.1,0.6-3.4,0.6c-0.8,0-1.5-0.1-2.1-0.4c-0.6-0.3-1.1-0.6-1.4-1c-0.3-0.4-0.5-1-0.6-1.7c-0.1-0.5-0.1-1.5-0.1-3v-7
		h-2v-3.4h2v-3.2l4.3-2.5v5.7H853.9z"
        />
        <path
            d="M863.9,114.3h-4.3V98.3h4v2.3c0.7-1.1,1.3-1.8,1.8-2.1c0.5-0.3,1.2-0.5,1.8-0.5c1,0,1.9,0.3,2.8,0.8l-1.3,3.7
		c-0.7-0.5-1.4-0.7-2-0.7c-0.6,0-1.1,0.2-1.5,0.5c-0.4,0.3-0.7,0.9-1,1.8c-0.2,0.9-0.4,2.7-0.4,5.4V114.3z"
        />
        <path
            d="M872.8,98.3h4.5l3.8,11.4l3.8-11.4h4.4l-5.7,15.5l-1,2.8c-0.4,0.9-0.7,1.7-1.1,2.1c-0.3,0.5-0.7,0.9-1.2,1.2
		c-0.4,0.3-1,0.5-1.6,0.7c-0.6,0.2-1.4,0.3-2.2,0.3c-0.8,0-1.6-0.1-2.4-0.3l-0.4-3.3c0.7,0.1,1.3,0.2,1.8,0.2c1,0,1.7-0.3,2.2-0.9
		c0.5-0.6,0.8-1.3,1.1-2.2L872.8,98.3z"
        />
    </g>
</svg>
